module.exports = __webpack_public_path__ + "img/active-layer9.476bc923.png";